import type { Brand, BrandEntry } from "./types";

/**
 * 各入口标题:品牌给了逐字覆写就用(DEFAULT 靠它保证与改造前一字不差),
 * 否则按品牌名拼 —— 渠道/中性品牌不会出现「GEO AI」「销帮」。
 */
export function documentTitleFor(entry: BrandEntry, brand: Brand): string {
  const fixed = brand.titles?.[entry];
  if (fixed) return fixed;
  switch (entry) {
    case "platform":
      return `${brand.productName} 平台后台`;
    case "tenant":
      return `${brand.productName} 租户后台`;
    case "wecom-h5":
      return `${brand.name} 陪练`;
    case "advisor":
      return `经营${brand.persona.title}`;
    case "voice":
      return "语音陪练";
    case "main":
    default:
      return brand.productName;
  }
}

function upsertMeta(doc: Document, name: string, content: string) {
  let el = doc.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = doc.createElement("meta");
    el.setAttribute("name", name);
    doc.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * 把品牌落到 document:title / description / favicon(设计稿 §1)。
 * ★favicon 只在品牌给了 faviconUrl 时动:直营不给 → html 里原有的 /robot.svg 原样保留。
 *   页面没有 icon link(H5)时才新建一个。
 */
export function applyDocumentBrand(
  entry: BrandEntry,
  brand: Brand,
  doc: Document = document
): void {
  doc.title = documentTitleFor(entry, brand);
  if (brand.description) upsertMeta(doc, "description", brand.description);

  if (brand.faviconUrl) {
    const links = Array.from(doc.head.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]'));
    if (links.length === 0) {
      const link = doc.createElement("link");
      link.rel = "icon";
      doc.head.appendChild(link);
      links.push(link);
    }
    for (const link of links) {
      link.href = brand.faviconUrl;
      link.removeAttribute("type"); // 原 type=image/svg+xml,换成任意格式时别让浏览器按 svg 解
    }
  }
}
